var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr-code"},[_c('img',{staticClass:"qr-code-img",attrs:{"src":_vm.imgsrc,"alt":"Qr Code per ritirare l'ordine"},on:{"click":function($event){_vm.dialog = true}}})])}
var staticRenderFns = []

export { render, staticRenderFns }